import { Box, TableCell, TableHead, TableRow } from '@material-ui/core';
import React from 'react';
import { addMonths, differenceInCalendarMonths, format, lastDayOfMonth, startOfMonth } from 'date-fns';
import clsx from 'clsx';
import { useTableStyles } from './Subledger.styled';
import { useAccountProvider } from '../../core/accountContext';
import { getAssetSumForMonth, getStartEndDate } from './common';
import COLORS from '../../variables/colors';
import currencyFormatter from '../../util/currencyFormatter';
import { Subledger } from '../../variables/types';
import { DAY_SHORT_FORMAT, FULL_DATE_FORMAT } from '../../variables/constants';

interface Props {
  subledger: Subledger;
}

const CreateSubledgerTableHeader = ({ subledger }: Props) => {
  const tableClasses = useTableStyles();
  const { account } = useAccountProvider();

  const renderAmortizationSchedulesHeader = () => {
    const { startDate, endDate } = getStartEndDate(subledger);
    if (startDate && endDate) {
      const diffInMonths = differenceInCalendarMonths(lastDayOfMonth(endDate!), startOfMonth(startDate!)) + 1;
      if (diffInMonths > 0) {
        return (
          <>
            {
              Array.from(Array(diffInMonths).keys()).map((index: number) => {
                const dayOfMonth = lastDayOfMonth(addMonths(startDate!, index));
                const currentDate = format(dayOfMonth, DAY_SHORT_FORMAT);
                return (
                  <TableCell
                    className={clsx(tableClasses.amortizationRowCell, {
                      [tableClasses.cellBackground]: index % 2 === 0,
                    })}
                    style={{ borderLeft: index === 0 ? `1px solid ${COLORS.lightGray2}` : 'none' }}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="stretch"
                      width="100"
                      padding={0}
                      margin={0}
                    >
                      <Box
                        className={tableClasses.amortizationRowCellHeader}
                      >
                        {currencyFormatter.format(getAssetSumForMonth(currentDate, subledger?.prepaidAssets))}
                      </Box>
                      <Box className={tableClasses.amortizationRowCellHeaderCurrency}>
                        {format(dayOfMonth, FULL_DATE_FORMAT)}
                      </Box>
                    </Box>
                  </TableCell>
                );
              })
            }
          </>
        );
      }
    }
    return null;
  };

  return (
    <TableHead>
      <TableRow
        hover={false}
      >
        <TableCell className={tableClasses.assetCell}>
          Asset ID
        </TableCell>
        <TableCell className={tableClasses.descriptionCell}>
          Description
        </TableCell>
        <TableCell className={tableClasses.customerCell}>
          Vendor
        </TableCell>
        <TableCell className={tableClasses.expenseAccountCell}>
          Expense Account
        </TableCell>
        {
          (account?.classTrackingPerTxnLine || account?.classTrackingPerTxn) && (
            <TableCell className={tableClasses.classesCell}>
              Class
            </TableCell>
          )
        }
        <TableCell className={tableClasses.currencyCell}>
          Facta STARTING BALANCE
        </TableCell>
        <TableCell className={tableClasses.datePickerCell}>
          Amortization Start Date
        </TableCell>
        <TableCell className={tableClasses.datePickerCell}>
          Amortization End Date
        </TableCell>
        <TableCell className={tableClasses.scheduleTypeCell}>
          Amort. Schedule
        </TableCell>
        <TableCell className={tableClasses.actionCell} />
        {
          renderAmortizationSchedulesHeader()
        }
      </TableRow>
    </TableHead>
  );
};

export default React.memo(CreateSubledgerTableHeader);
